export const CLASSPREFIX = 'muze';
export const IDFIELD = '__id__';
export const CONFIG = 'config';
export const DATAMODEL = 'dataModel';
export const AXES = 'axes';
export const LAYERDEFS = 'layerDef';
export const WIDTH = 'width';
export const MAXWIDTH = 'max-width';
export const HEIGHT = 'height';
export const MOUNTPOINT = 'mountPoint';
export const GRIDLINEPARENTGROUPCLASS = 'grid-lines';
export const TRANSFORM = 'transform';
export const CONSOLIDATED = 'consolidated';
export const FRAGMENTED = 'fragmented';
export const DEFAULTCOLOR = '#F44336';
export const DEFAULTSIZE = 50;
export const VERTICAL_BUFFER = 10;
export const HORIZONTAL_BUFFER = 2;
export const DEFAULTICONSIZE = { // approximately the (size needed) * Math.PI value
    circle: 64,
    square: 45.8,
    default: 42.8
};
export const DEFAULTSHAPE = 'circle';
export const STEP = 'step';
export const GRADIENT = 'gradient';
export const ORDINAL = 'ordinal';
export const SCALE_FUNCTIONS = {
    size: 'getSize',
    shape: 'getShape',
    color: 'getColor'
};
export const TOP = 'top';
export const LEFT = 'left';
export const RIGHT = 'right';
export const BOTTOM = 'bottom';
export const HORIZONTAL = 'horizontal';
export const VERTICAL = 'vertical';
export const CENTER = 'center';
export const VALUE = 'value';
export const PATH = 'path';
export const SHAPE = 'shape';
export const ICON = 'icon';
export const RECT = 'rect';
export const START = 'start';
export const UPPER = 'upper';
export const LOWER = 'lower';
export const END = 'end';
export const SIZE = 'size';
export const DISCRETE = 'discrete';
export const MEASURE = 'measure';
export const DEFAULT = 'default';

export const POSITION_ALIGNMENT_MAP = {
    [LEFT]: VERTICAL,
    [RIGHT]: VERTICAL,
    [TOP]: HORIZONTAL,
    [BOTTOM]: HORIZONTAL
};

export const OPPOSITE_POSITION = {
    [LEFT]: RIGHT,
    [RIGHT]: LEFT
};

